/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

	const body = document.body;
	const header = document.querySelector('.site-header');
	const footer = document.querySelector('.site-footer');
	const tablet_breakpoint = 990;
	const mobile_breakpoint = 750;

	// Toggle class on body when .j-menu-toggle is clicked
	document.addEventListener('click', function(event) {
	    if (event.target.closest('.j-menu-toggle')) {
	        body.classList.toggle('menu-drawer-expanded');
	    }
	});

	// Only run if screen width is less than tablet_breakpoint
	if (window.innerWidth < tablet_breakpoint) {
	    document.addEventListener('click', function(event) {
	        const linkParent = event.target.closest('.site-header .header-menu-container .link-item a.link-parent');

	        if (linkParent) {
	            event.preventDefault();

	            // Check if the parent has data-megamenu
	            const parentElement = linkParent.parentElement;
	            if (parentElement.hasAttribute('data-megamenu')) {
	                console.log("Parent has data-megamenu attribute!");
	                parentElement.classList.toggle('expanded');
	            }
	        }
	    });
	}

	class UpsellCardsCart extends HTMLElement {
		constructor() {
			super()
		}
	
		connectedCallback() {
			this.initCarousel()
		}
		initCarousel() {
			if (
				!!this.querySelector(".products-carousel") &&
				this.querySelector(".products-carousel").children.length > 1
			) {
				setTimeout(() => {
					const carousel = new window.theme.Flickity(
						this.querySelector(".products-carousel"),
						{
							pageDots: false,
							cellAlign: "left",
							// wrapAround: true,
							contain: true,
							prevNextButtons: false,
						},
						1000
					)
					this.querySelector('.arrow-next-custom').addEventListener('click', function() { carousel.next()})
					this.querySelector('.arrow-prev-custom').addEventListener('click', function() { carousel.previous() })
					const self = this

					carousel.on( 'change', function( index ) {
						if (index === 0) {	
							self.querySelector('.arrow-prev-custom').classList.add('disabled')
						} else {
							self.querySelector('.arrow-prev-custom').classList.remove('disabled')
						}
						if (index === carousel.slides.length - 1) {
							self.querySelector('.arrow-next-custom').classList.add('disabled')
						} else {
							self.querySelector('.arrow-next-custom').classList.remove('disabled')
						}
					});
				})
			}
		}
	}
	
	if (!customElements.get("upsell-carousel-cart")) {
		customElements.define("upsell-carousel-cart", UpsellCardsCart)
	}
  
    document.querySelectorAll(".j-toggle-swatch-drawer").forEach(button => {
        button.addEventListener("click", function () {
            const swatchDrawer = this.closest(".product__content")?.querySelector(".swatch-drawer");
            if (swatchDrawer) {
                swatchDrawer.classList.toggle("active");
            }
        });
    });


	document.addEventListener("DOMContentLoaded", function () {
	  const variantInput = document.querySelector('input.j-selected-variant');
	  const variantSelect = document.querySelector('select.variant_selector');
	  const inStockBlock = document.querySelector('.product__block.in_stock_block');

	  if (!variantInput || !variantSelect || !inStockBlock) return;

	  variantInput.addEventListener('change', function () {
	    const inputValue = variantInput.value;

	    const matchingOption = Array.from(variantSelect.options).find(function (option) {
	      return option.value === inputValue;
	    });

	    if (matchingOption) {
	      variantSelect.value = matchingOption.value;

	      // Trigger change event manually if needed
	      const event = new Event('change', { bubbles: true });
	      variantSelect.dispatchEvent(event);

	      // Check availability
	      const isAvailable = matchingOption.dataset.availability === 'true';

	      if (isAvailable) {
	        inStockBlock.classList.add('active');
	      } else {
	        inStockBlock.classList.remove('active');
	      }
	    }
	  });
	});

	document.addEventListener('DOMContentLoaded', function () {
	  const modal = document.querySelector('.size-guide-component--modal');
	  const innerModal = document.querySelector('.modal--inner');
	  const triggers = document.querySelectorAll('[data-size-guide-toggle]');

	  // Toggle modal visibility on trigger click
	  triggers.forEach(function (trigger) {
	    trigger.addEventListener('click', function (e) {
	      e.preventDefault();
	      if (modal) {
	        modal.classList.toggle('active');
	      }
	    });
	  });

	  // Close only if clicking outside of modal--inner
	  document.addEventListener('click', function (e) {
	    if (
	      modal &&
	      modal.classList.contains('active') &&
	      !innerModal.contains(e.target) &&
	      !e.target.closest('[data-size-guide-toggle]')
	    ) {
	      modal.classList.remove('active');
	    }
	  });
	});







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
